export enum KYC_INPUT_TYPE {
  TEXT = 'text',
  NUMBER = 'number',
  TEXTAREA = 'textarea',
  SELECT = 'select',
  TEXT_AND_UPLOAD = 'text_and_upload',
  MULTIPLE = 'multiple'
}

export enum KYC_STATUS {
  PENDING = 'pending',
  SUBMITTED = 'submitted',
  SUCCESSFUL = 'successful',
  FAILED = 'failed'
}

export enum ID_TYPE {
  AADHAAR = 'Aadhaar',
  DRIVING_LICENSE = 'Driving license',
  VOTER_ID = 'Voter ID',
  PASSPORT = 'Passport',
  OTHER = 'Other'
}

export enum PAYMENT_MODE {
  INTERNAL = 'internal',
  EXTERNAL = 'external'
}

export interface KycDetails {
  version: number;
  name: string;
  address: string;
  bankDetails: {
    ifscCode: string;
    name: string;
    accountNumber: string;
    nameAPBankAccount: string;
  };
  gstin?: string;
  idProof: {
    number: string;
    proofType: string;
    file?: string;
    fileFrontSide?: string;
    fileBackSide?: string;
  };
  pan: {
    number: string;
    file?: string;
    fileFrontSide?: string;
    fileBackSide?: string;
  };
  status: KYC_STATUS;
}

export interface BankingDetails {
  label: string;
  value: string;
  error: string;
}

export interface KYCInput {
  label: string;
  desc: string;
  type: KYC_INPUT_TYPE;
  value: string;
  options?: string[];
  inputs?: KYCInput[];
  uploadCta?: string;
  error?: string;
}

export interface KYCFilesType {
  type?: string;
  frontSide?: File;
  backSide?: File;
  frontSidePreview?: string | ArrayBuffer | null;
  backSidePreview?: string | ArrayBuffer | null;
}

export type GetKYCStatusResponseType = {
  kycStatus: KYC_STATUS;
  unsettledRevenue: string;
  isPaymentEnabled: string;
  paymentMode: PAYMENT_MODE;
  paymentVendor: string;
  hasMultipleInstructors?: boolean;
  isMemberInstructor: boolean;
};
